import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ef3f9ab2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-helper" }

import BaseButton from '@/components/BaseButton.vue'
import { FORMATS } from '@/enums/components'


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoHelper',
  props: {
  contentLeft: {
    type: Boolean,
    default: false,
  },
  iconSize: {
    type: Number,
    default: 24,
  },
  icon: {
    type: String,
    default: 'question',
  },
  contentStyle: Array[(String, Array, Object, undefined)],
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_VDropdown = _resolveComponent("VDropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VDropdown, _mergeProps(_ctx.$attrs, { triggers: ['hover', 'click', 'focus'] }), {
      popper: _withCtx(() => [
        _renderSlot(_ctx.$slots, "content", {}, () => [
          _createElementVNode("div", {
            class: "info-helper__content",
            style: _normalizeStyle(__props.contentStyle)
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 4)
        ])
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "activator", {}, () => [
          _createVNode(BaseButton, {
            type: "button",
            format: _unref(FORMATS).ICON,
            class: "info-helper__button",
            icon: __props.icon,
            "icon-size": __props.iconSize
          }, null, 8, ["format", "icon", "icon-size"])
        ])
      ]),
      _: 3
    }, 16)
  ]))
}
}

})